﻿const calcHeightNav = {
  init: function() {
    this.dropdownItem = document.getElementsByClassName("dropdown-icon");
    this.mainDropdownBtn = document.getElementById("main-nav__btn");
    this.mainNav = document.getElementById("main-nav__primary");
    this.secondaryNav = document.getElementById("secondary-nav");
    this.mainNavPos = document.getElementById("main-nav");
    this.mainNavItem = document.querySelectorAll(".main-nav__item");

    this.events();
  },

  events: function() {
    for (let counter = 0; counter < this.dropdownItem.length; counter++) {
      this.dropdownItem[counter].classList.remove("active");

      this.dropdownItem[counter].addEventListener("click", () => {
        if (
          this.dropdownItem[counter].parentElement.classList.contains("active")
        ) {
          this.dropdownItem[counter].parentElement.classList.remove("active");
        } else {
          this.dropdownItem[counter].parentElement.classList.add("active");
        }
      });
    }
  }
};

export default calcHeightNav.init();
